import React, { useState } from "react";
import { Col, Button, Divider } from "antd";
import { EyeOutlined, EyeInvisibleOutlined } from "@ant-design/icons";
import FilterCategories from "./advanced_settings/FilterCategories";
import FilterVisitsCount from "./advanced_settings/FilterVisitsCount";
import BookingActions from "./advanced_settings/BookingActions";
import { useFormContext } from "react-hook-form";
import { useParams } from "react-router-dom";
import translator from "@/translator";
const t = translator("front_office.views.yclients_notification_settings.");

const AdvancedSettings = () => {
  const { action_type } = useParams();
  const { watch } = useFormContext();
  const [isOpen, setIsOpen] = useState(false);

  const selectedServices = watch("salon_service_id_and_title", []);
  const isDisabled = (selectedServices || []).length === 0 && !isOpen;

  const toggleOpen = () => {
    setIsOpen((open) => !open);
  };

  return (
    <>
      <Col span={24}>
        <Button
          className="ant-custom-btn"
          type="primary"
          style={{ width: "100%" }}
          onClick={toggleOpen}
          disabled={isDisabled}
          icon={isOpen ? <EyeInvisibleOutlined /> : <EyeOutlined />}
        >
          {isOpen ? t("fields.hide_advanced_settings") : t("fields.show_advanced_settings")}
        </Button>
      </Col>
      <Col style={{ display: isOpen ? "block" : "none" }} span={24}>
        {action_type === "booking_action" && (
          <>
            <BookingActions />
            <Divider />
          </>
        )}

        <FilterVisitsCount />
        <Divider />

        {action_type !== "cross_sell" && action_type !== "return_visit" && (
          <FilterCategories />
        )}
      </Col>
    </>
  );
};

export default AdvancedSettings;
